import cleanedFilename from '~/util/cleanedFilename';

export default {
  PERSONALISE_BUTTON: `${cleanedFilename(__filename)}-personalise-button`,
  LABEL: `${cleanedFilename(__filename)}-label`,
};
